import { DateTime } from "luxon";

export function getLastMonthDateRange() {
  const now = DateTime.now();
  const start = now.minus({ months: 1 });
  const end = now;

  return { start, end };
}
